import hasGrade from '$utils/hasGrade';
import { DO_NOT_EXPORT } from '$utils/overrideConstants';
import overrideOptions from '$utils/overrideOptions';

const filterStudentsGrades = ({
  grades = [],
  overrides = [],
  successfulExports,
}) =>
  grades.reduce(
    ({ exported, notExported }, grade) => {
      const student = successfulExports.find(
        ({ studentId }) => studentId === grade.studentId
      );

      // student is failed to export
      if (!student) {
        return { exported, notExported };
      }

      const studentOverride = overrides.find(
        ({ studentId }) => studentId === grade.studentId
      );

      if (
        (studentOverride && studentOverride.code === DO_NOT_EXPORT) ||
        // backward compatible
        (!studentOverride && !hasGrade({ displayGrade: grade.grade }))
      ) {
        return {
          exported,
          notExported: [...notExported, grade],
        };
      }

      // ignore if student has no override code or if override code is invalid
      const override = studentOverride && overrideOptions[studentOverride.code];

      return {
        exported: [
          ...exported,
          override ? { ...grade, displayGrade: override } : grade,
        ],
        notExported,
      };
    },
    {
      exported: [],
      notExported: [],
    }
  );

export default filterStudentsGrades;
